import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import styled, { css } from "styled-components";

export const SearchResultsWrapper = styled.div<{
  $addDesktopGutter?: boolean;
}>`
  position: relative;
  left: 0;
  width: 100%;

  ${responsiveMediaQueries.desktopAndAbove} {
    max-width: 1920px;
    margin: auto;
    padding: ${({ $addDesktopGutter }) =>
      $addDesktopGutter ? getSpacing(0, "6x") : undefined};
  }
  ${responsiveMediaQueries.tabletAndBelow} {
    padding: ${getSpacing(0, "2x")};
  }
`;

export const headerStyles = css`
  ${responsiveMediaQueries.tabletAndAbove} {
    margin: 0;
  }
`;

export const SubHeader = styled(Typography)`
  ${headerStyles}
`;

// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
export const ResultInfoRow = styled(Row).attrs({ align: "baseline" })`
  &&& {
    ${responsiveMediaQueries.tabletAndBelow} {
      display: flex;
    }
  }
`;
